/**
 * Themed section class groups — single source of truth for structural CSS,
 * EMAIL_THEME_SETTING_TARGETS, and EmailCssService theme generation.
 */
/** Bordered detail blocks (canonical: content-section). Legacy names remain CSS aliases. */
export const EMAIL_THEME_CONTENT_SECTION_CLASSES = [
    'content-section',
    'customer-section',
    'info-section',
    'invoice-details',
    'job-details',
    'payment-info-section',
    'payment-details',
];
/** Centered highlight blocks (amount, schedule, ETA). */
export const EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES = [
    'amount-due-section',
    'schedule-section',
    'amount-section',
    'amount-paid',
    'schedule-change',
    'eta-card',
    'pricing-option',
    'payment-method',
    'payment-options',
];
/** Notice / status blocks (due dates, alerts, security). */
export const EMAIL_THEME_NOTICE_SECTION_CLASSES = [
    'due-date',
    'validity-notice',
    'security-note',
    'reminder-message',
    'alert-box',
    'message-box',
    'summary-box',
    'thank-you-section',
];
/** Line-item and table wrapper sections. */
export const EMAIL_THEME_ITEMS_SECTION_CLASSES = ['items-section'];
/** All section classes that receive sectionBg + sectionPadding from theme. */
export const EMAIL_THEME_SECTION_BG_CLASSES = [
    ...EMAIL_THEME_CONTENT_SECTION_CLASSES,
    ...EMAIL_THEME_ITEMS_SECTION_CLASSES,
    ...EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES,
    ...EMAIL_THEME_NOTICE_SECTION_CLASSES,
];
export function emailThemeClassesToSelectors(classes) {
    return classes.map((c) => `.${c}`);
}
export function emailThemeClassesToSelectorString(classes) {
    return emailThemeClassesToSelectors(classes).join(', ');
}
/** Legacy content-section aliases (for docs / registry). */
export const EMAIL_THEME_CONTENT_SECTION_LEGACY_ALIASES = [
    'customer-section',
    'info-section',
    'invoice-details',
    'job-details',
    'payment-info-section',
    'payment-details',
];
//# sourceMappingURL=emailSectionGroups.js.map